import React from 'react'
import TenantReview from '../Components/Review/TenantReview'

const TenantReviewPage = () => {
  return (
    <TenantReview />
  )
}

export default TenantReviewPage